// fetchToolPreviewApi.js
import { apiSlice } from '../../app/api/apiSlice';

export const fetchToolPreviewApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    fetchToolPreview: builder.mutation({
      query: ({ body }) => ({
        url: '/v1/tool/preview',
        method: 'POST',
        body,
      }),
      keepUnusedDataFor: 0,
    }),
    regenerateToolPreview: builder.mutation({
      query: ({ id }) => ({
        url: `/v1/tool/createpreview/${id}`,
        method: 'GET'
      }),
      keepUnusedDataFor: 0,
      invalidatesTags: ["ToolProfile"]
    }),
  }),
});

export const {
  useFetchToolPreviewMutation,
  useRegenerateToolPreviewMutation
} = fetchToolPreviewApi;
